export const PAGE_SIZES = [10, 20, 50, 100];
export const [DEFAULT_PAGE_SIZE] = PAGE_SIZES;

export const MOBILE_BREAKPOINT = 600;

export enum Navigation {
    RELATED = 'related',
    DETECTIONS = 'detections',
    AFFECTED = 'affected',
    PACKAGES = 'packages',
    REFERENCES = 'references',
    SOCIAL = 'social',
    PATHS = 'paths',
    CODE = 'code',
    FIX = 'fix'
}
